import {fire} from "../../fire";
import {doc, writeBatch} from 'firebase/firestore'

export const guardarDocs = ({col, arrObj}) => {


    let batch = writeBatch(fire)

    for (let i = 0; i < arrObj.length; i++) {
        if (!arrObj[i].id) {
            let id = new Date().getTime() + col.substr(col.length - 3, col.length).toUpperCase();
            arrObj[i].id = id;
        }
        const nycRef = doc(fire, col, arrObj[i].id);
        batch.set(nycRef, arrObj[i])
    }


    return batch.commit()

}